import { render, staticRenderFns } from "./TalentListItem.vue?vue&type=template&id=21c1a0b4&scoped=true"
import script from "./TalentListItem.vue?vue&type=script&lang=js"
export * from "./TalentListItem.vue?vue&type=script&lang=js"
import style0 from "./TalentListItem.vue?vue&type=style&index=0&id=21c1a0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1a0b4",
  null
  
)

export default component.exports